import { Component, Input, OnChanges } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { TypedChanges } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { PLATFORM_TRANSLOCO_SCOPE } from '../../platform-transloco-scope';
import { PollingConfiguration } from '../model/polling-configuration';
import { PollingStatus } from '../model/polling-status';
import { PollingService } from '../polling.service';

@Component({
  selector: 'yat-polling-status',
  templateUrl: './polling-status.component.html',
  styleUrls: ['./polling-status.component.scss'],
  providers: [provideTranslocoScope(PLATFORM_TRANSLOCO_SCOPE)]
})
export class PollingStatusComponent implements OnChanges {
  constructor(private pollingService: PollingService) {}

  @Input()
  reconnectingText?: string | null;

  @Input()
  configuration: PollingConfiguration;

  status$: Observable<PollingStatus>;

  ngOnChanges(changes: TypedChanges<PollingStatusComponent>): void {
    if (changes.configuration) {
      this.status$ = this.pollingService.getPollingObservable(this.configuration);
    }
  }
}
